import { Status } from '@/models/CommonModels';

export type State = {
  status: Status;

  publicPages: Array<string>;
  benutzerPages: Array<string>;
  adminPages: Array<string>;

  qrCodeTrennzeichen: string;
};

export const state: State = {
  status: new Status(),

  // publicPages: ['Login', 'Logout', 'Home'],
  publicPages: ['Login', 'Logout'],

  benutzerPages: [
    'Dashboard',
    'Personaldaten',
    'DetailsPersonaldaten',
    'Signaturen',
    'DetailsSignatur',
    'Vertraege',
    'EditVertrag',
    'DetailsVertrag',
    'EditVertragDokument',
    'Vertragspartner',
    'DetailsVertragspartner',
    'Vorlagen',
    'DetailsVorlage',
  ],

  adminPages: ['Einstellungen', 'Druckvorlagen', 'EditSignatur', 'EditVertragspartner', 'EditVorlage', 'Textbausteine', 'EditTextbaustein', 'Textvariablen'],

  qrCodeTrennzeichen: '_',
};
